import * as Blockly from 'blockly/core';

export class FieldStyledBadgeLabel extends Blockly.Field<string> {
    private foreignObject_: SVGForeignObjectElement | null = null;
    private isDisabled_ = false;

    constructor(
        value: string,
        private readonly maxWidth?: number,
        private readonly paddingRight?: number,
    ) {
        super(value);
        this.SERIALIZABLE = false;
    }

    private measureText(text: string): number {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) return (text.length ?? 1) * 12 + 20;
        ctx.font = '500 16px sans-serif';
        return Math.ceil(ctx.measureText(text).width) + 20;
    }

    private get width_(): number {
        const value = this.getValue() ?? '';
        if (value === '') return 0;

        const measured = this.measureText(this.getValue() ?? '');
        const hasDegree = (this.getValue() ?? '').includes('°');
        const adjusted = hasDegree ? measured + 6 : measured;
        return this.maxWidth ? Math.min(adjusted, this.maxWidth) : adjusted;
    }

    override initView() {
        this.foreignObject_ = Blockly.utils.dom.createSvgElement(
            'foreignObject' as any,
            { width: this.width_, height: 34 },
            this.fieldGroup_,
        ) as unknown as SVGForeignObjectElement;
        this.renderContent_();
    }

    private renderContent_() {
        const fo = this.foreignObject_;
        if (!fo) return;

        while (fo.firstChild) fo.removeChild(fo.firstChild);
        fo.setAttribute('width', String(this.width_));
        fo.setAttribute('height', '34');

        const ns = 'http://www.w3.org/1999/xhtml';
        const div = document.createElementNS(ns, 'div') as HTMLDivElement;
        const hasDegree = (this.getValue() ?? '').includes('°');
        div.style.cssText = [
            'display:flex',
            'align-items:center',
            hasDegree ? 'justify-content:flex-start' : 'justify-content:center',
            hasDegree ? 'padding-left:8px' : '',
            'height:34px',
            `width:${this.width_}px`,
            'border-radius:6px',
            `border:1.5px solid ${this.isDisabled_ ? 'rgba(255,255,255,0.3)' : 'rgba(255,255,255,0.6)'}`,
            `background:${this.isDisabled_ ? 'rgba(255,255,255,0.15)' : 'rgba(255,255,255,0.3)'}`,
            `color:${this.isDisabled_ ? 'rgba(255,255,255,0.55)' : 'white'}`,
            'font-size:16px',
            'font-weight:500',
            'user-select:none',
            'pointer-events:none',
            this.paddingRight ? `padding-right:${this.paddingRight}px` : '',
        ]
            .filter(Boolean)
            .join(';');
        div.textContent = this.getValue();
        fo.appendChild(div);
    }

    public setDisabled(disabled: boolean): void {
        if (this.isDisabled_ === disabled) return;
        this.isDisabled_ = disabled;
        this.renderContent_();
    }

    override render_() {
        this.renderContent_();
    }

    override doValueUpdate_(newValue: string) {
        super.doValueUpdate_(newValue);
        this.renderContent_();
    }

    override getSize() {
        return new Blockly.utils.Size(this.width_, 34);
    }

    override getDisplayText_() {
        return this.getValue() ?? '';
    }
}
